export default __webpack_public_path__ + "static/media/sc23.56240223.jpg";